import React from "react"

// Components
import CasinoPage from "../components/CasinoPage"

export default () => (
  <CasinoPage />
)
